import { render, staticRenderFns } from "./LossNotification.vue?vue&type=template&id=d06fb67a&"
import script from "./LossNotification.vue?vue&type=script&lang=js&"
export * from "./LossNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports